import React from 'react';
import { get } from 'global/lib/lodash';
import AssessmentScore from '.';
import { multiStyles } from './styles';
import printStyles from 'global/components/print/print-view/styles';
import { useLoaded } from 'global/hooks/useLoaded';

export default (props) => {
  const { assessment } = props;
  const classes = multiStyles();
  const pstyles = printStyles();

  const cards = get(assessment, 'data.scorecards', []);

  useLoaded(props, [!cards]);

  return (
    <>
      {cards.map((card, i) => {
        return (
          <div className={i !== 0 && pstyles.pagebreak}>
            <div className={classes.scorecardTitle}>{get(card, 'name')}</div>
            <AssessmentScore {...props} scIndex={i} />
          </div>
        );
      })}
    </>
  );
};
